import { lazy } from "react";
import Loadable from "app/components/Loadable";

const WhatsAppTemplateReviewPage = Loadable(
  lazy(() => import("./WhatsAppTemplateReviewPage"))
);

const WhatsAppTemplateReviewRoutes = [
  {
    path: "/admin/whatsapp-templates",
    element: <WhatsAppTemplateReviewPage />,
  },
];

export default WhatsAppTemplateReviewRoutes;
